import React from "react"
import PropTypes from "prop-types"
import { Link, BrowserRouter as Router } from "react-router-dom"
import cx from "classnames"

// Components
import HorizontalScoreBar from "../HorizontalScoreBar/HorizontalScoreBar"
import resizeComponent from "../ResizeComponent/ResizeComponent"
import Icon from "../Icon"

// Resizable Components
const ResizableHorizontalScoreBar = resizeComponent(HorizontalScoreBar)

const TableRow = props => {
  const { keys, item, rowSpacing, getScores, childLevel } = props

  const getDivProps = (key, scoreBar) => {
    const defaultClasses = "scores-tr d-flex text-truncate"
    const className = scoreBar
      ? `${defaultClasses} scorebar justify-content-center pr-2 pl-2`
      : `${defaultClasses} pt-1`
    return {
      key: `${key}-${item.id}`,
      style: rowSpacing,
      className
    }
  }

  return (
    <div className="d-flex" key={`tr-${item.id}`}>
      {keys.map(key => {
        let displayData = item[key]
        if (getScores) displayData = getScores(key, item)

        const scoreBar = typeof displayData !== "string" && key !== "name"

        const scoreBarProps = {
          score: displayData,
          barColor: key === "teamSize" ? "#B6C2D8" : null
        }
        const linkProps = {
          to: `/engagement/vision2/insights/${childLevel}/${item.id}`,
          className: cx("text-truncate mr-2", {
            "demo-tour-step-9": !scoreBar && displayData === "Veronica Calderón"
          })
        }

        return (
          <div {...getDivProps(key, scoreBar)}>
            {scoreBar ? (
              <ResizableHorizontalScoreBar {...scoreBarProps} />
            ) : item.is_manager && !item.is_team_manager ? (
              <Router>
                <Link {...linkProps}>{displayData}</Link>
              </Router>
            ) : (
              <span className="">
                <span className="text-truncate mr-2 mb-0 ">{displayData}</span>
                {item.is_team_manager && (
                  <span>
                    <Icon name="personCircle" />
                  </span>
                )}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default TableRow

TableRow.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  item: PropTypes.shape({
    id: PropTypes.any,
    name: PropTypes.string,
    is_manager: PropTypes.bool,
    is_team_manager: PropTypes.bool,
    scores: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        scores: PropTypes.shape({
          score: PropTypes.number
        })
      })
    )
  }).isRequired,
  rowSpacing: PropTypes.shape({
    flex: PropTypes.string,
    minWidth: PropTypes.string
  }).isRequired,
  getScores: PropTypes.func.isRequired,
  childLevel: PropTypes.string.isRequired
}
